import React from 'react'
import styles from './PreviewModal.scss'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'

export class PreviewModal extends React.PureComponent {
  render () {
    const {onRequestClose, experience} = this.props

    return (
      <ModalOverlay
        maxWidth={780}
        onRequestClose={onRequestClose}>
        <div className={styles.previewContainer}>
          <div className={styles.previewInner}>
            <iframe className={styles.previewIframe} src={`/experiences/${experience.id}/pages/home.html`} />
          </div>
        </div>
      </ModalOverlay>
    )
  }
}
